import { useTranslation } from "react-i18next";

export interface SignInGateI18n {
  sloganLead: string;
  sloganAccent: string;
  networkAria: string;
  failedTitle: string;
  blockedTitle: string;
  blockedLead: string;
  lead: string;
  failedLead: string;
  signIn: string;
  tryAgain: string;
  signingIn: string;
  popupHintTitle: string;
  popupHintBody: string;
  secureTitle: string;
  secureBody: string;
  residencyTitle: string;
  residencyBody: string;
  learnMore: string;
  logoAlt: string;
}

export const useSignInGateI18n = (): SignInGateI18n => {
  const { t } = useTranslation();
  return {
    sloganLead: t("auth.signInGate.sloganLead", "Your tasks can run..."),
    sloganAccent: t("auth.signInGate.sloganAccent", "but they can't hide."),
    networkAria: t(
      "auth.signInGate.networkAria",
      "Tasks from Outlook, Planner, Jira, Trello and GitHub flowing into one OneTaskList board",
    ),
    failedTitle: t("auth.signInGate.failedTitle", "That didn't finish"),
    blockedTitle: t("auth.signInGate.blockedTitle", "Pop-up blocked"),
    blockedLead: t(
      "auth.signInGate.blockedLead",
      "Your browser blocked the sign-in window. Allow pop-ups for this site, then try again.",
    ),
    lead: t(
      "auth.signInGate.lead",
      "OneTaskList brings together tasks from Microsoft 365, Jira, Trello, GitHub and more into one personal workspace.",
    ),
    failedLead: t(
      "auth.signInGate.failedLead",
      "Sign-in didn't complete. Nothing was lost — give it another go.",
    ),
    signIn: t("auth.signInGate.signIn", "Sign in"),
    tryAgain: t("auth.signInGate.tryAgain", "Try again"),
    signingIn: t("auth.signInGate.signingIn", "Signing in..."),
    popupHintTitle: t("auth.signInGate.popupHintTitle", "A window will open"),
    popupHintBody: t(
      "auth.signInGate.popupHintBody",
      "Sign-in happens in a separate window. If nothing appears, allow pop-ups for this site and try again.",
    ),
    secureTitle: t("auth.signInGate.secureTitle", "Secure sign-in"),
    secureBody: t(
      "auth.signInGate.secureBody",
      "Handled by your identity provider. We never see your password.",
    ),
    residencyTitle: t("auth.signInGate.residencyTitle", "Your data stays put"),
    residencyBody: t(
      "auth.signInGate.residencyBody",
      "Boards are served from the region you signed up in.",
    ),
    learnMore: t("auth.signInGate.learnMore", "See how it works"),
    logoAlt: t("common.labels.appName", "OneTaskList"),
  };
};
